import React from 'react'

import '../container/FAQ.css';
import {FAQ_CATEGORY_MAP} from "../store/faqConstants";
import PaginationComponent from "../../../component/table/Pagination";

class FAQListTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openUid: null,
        }
        this.toggleAccordion = this.toggleAccordion.bind(this);
    }

    toggleAccordion(uid) {
        this.setState(prevState => ({
            openUid: prevState.openUid === uid ? null : uid
        }));
    }

    render() {
        const { total, page, size, faqList, navigate, searchType, setValue } = this.props;
        const { handlePageChange } = this.props;
        const { openUid } = this.state;

        return(
            <React.Fragment>
                <div className="faq-category-nav d-flex gap-2 flex-wrap align-items-center mb-3">
                    <div className="d-flex gap-2 flex-wrap flex-grow-1 me-4">
                        {Object.entries(FAQ_CATEGORY_MAP).map(([key, label]) => {
                            const isActive = Number(key) === Number(searchType);
                            return (
                                <button
                                    key={key}
                                    className={`btn flex-fill faq-category-item-btn ${isActive ? 'is-active-category' : ''}`}
                                    onClick={(e) => {
                                        setValue("searchType", Number(key));
                                        handlePageChange(e, 1);
                                    }}
                                >
                                    <span className={isActive ? 'fw-bold' : ''}>
                           {label}
                        </span>
                                </button>
                            );
                        })}
                    </div>
                </div>

                <section className='mt-4 faq-accordion-list'>
                    {faqList?.length !== 0 ? (
                        <div className="accordion" id="faqAdminAccordion">
                            {faqList?.map((item, index) => {
                                const isItemOpen = item.uid === openUid;
                                const itemNo = (page - 1) * size + (index + 1);
                                return (
                                    <div className="accordion-item" key={item.uid}>
                                        <h2 className="accordion-header d-flex justify-content-between align-items-stretch">

                                            <div
                                                className={`accordion-button p-3 ${isItemOpen ? '' : 'collapsed'}`}
                                                onClick={() => this.toggleAccordion(item.uid)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <span
                                                    className="me-4 text-primary fw-bold faq-category-fixed-width d-inline-block text-nowrap"
                                                >
                                                    {item.categoryName}
                                                </span>
                                                <span className="flex-grow-1 text-start me-4">{item.title}</span>
                                                {isItemOpen ? (
                                                    // 아코디언이 열렸을 때
                                                    <span className="text-muted text-nowrap small me-3 align-self-center">
                                                        {item.updatedAt.split(' ')[0]}
                                                    </span>
                                                ) : (
                                                    // 아코디언이 닫혔을 때 (내부 버튼)
                                                    <div className="d-flex justify-content-end align-self-center me-3 faq-action-buttons-fixed-width">
                                                    </div>
                                                )}
                                            </div>
                                        </h2>

                                        <div
                                            id={`collapse-${item.uid}`}
                                            className={`accordion-collapse collapse ${isItemOpen ? 'show' : ''}`}
                                            data-bs-parent="#faqAdminAccordion"
                                        >
                                            <div className="accordion-body p-4">
                                                <div style={{ marginLeft: '138px' }}>
                                                    <div className="faq-content" dangerouslySetInnerHTML={{ __html: item.content }} />
                                                    <div className="d-flex justify-content-end mt-3">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="text-center py-5 border">
                            No Data
                        </div>
                    )}

                    <PaginationComponent page={page} total={total} sizePerPage={size} handleChange={handlePageChange}/>
                </section>
            </React.Fragment>
        )
    }
}

export default FAQListTable;